import {EX} from "./exclaim.ts";
import {ValidatorsObj} from "./Validators.js";
import {addCsrfTokenToXhr} from "./CsrfTokenManagement.ts";
import {getServerRequestErrorMessage} from "./RequestUtils.ts";
// Disabled this import because it triggers the "registering" of JQueryUI with jQuery during module loading
// and causes problems with the unit tests -- Moved to the common page initialization to ensure it's included
//import "jquery-ui/dist/jquery-ui.js"

// export function commonAjaxBeforeSend(xhr: XMLHttpRequest, settings: JQuery.AjaxSettings): void;
export function commonAjaxBeforeSend(xhr, settings) {
    addCsrfTokenToXhr(xhr, settings?.type);
}

// export function alertP(message: string, title: string): Promise<void>;
export function alertP(message, title) {
    return new Promise((resolve) => alertDialog(message, title, resolve));
}

/**
 * @deprecated Use `alertDialog()` instead
 */
// export function alert(message: string, title: string, callback?: () => void): void;
export function alert(message, title, callback) {
    alertDialog(message, title, callback);
}

// This function could be moved to somewhere more generic
// export function alertDialog(message: string, title: string, callback?: () => void): void;
export function alertDialog(message, title, callback) {
    const buttons = {};
    buttons[EX.Messages.prop("Button_Ok")] = function () {
        $(this).dialog("close");
        if (typeof callback === "function") {
            callback();
        }
    };
    $("<div></div>", {
        dialog: {
            buttons: buttons,
            close: function (_event, _ui) {
                $(this).remove();
                if (typeof callback === "function") {
                    callback();
                }
            },
            resizable: false,
            title: title,
            modal: true
        },
        css: {"white-space": "pre-line"},
        addClass: "exclaim-jquery-dialog",
        text: message
    });
}

// export function confirm(
//     message: string,
//     title: string,
//     options?: JQueryUI.DialogOptions,
//     callback?: () => void,
//     defaultButtonIndex?: number,
// ): void;
export function confirm(message, title, buttons, options, callback, defaultButtonIndex) {
    const defaultButtons = [
        {
            text: EX.Messages.prop("Button_Ok"),
            click: function () {
                $(this).dialog("close");
            },
        }
    ];
    const dialogOptions = $.extend(options || {}, {
        buttons: buttons || defaultButtons,
        close: function (_event, _ui) {
            $(this).remove();
            if (typeof callback === "function") {
                callback();
            }
        },
        title: title,
        resizable: false,
        width: 400, // default is 300, so making it a bit wider as we have some long text in places
        modal: true,
        open: function (_event, _ui) {
            // Only try to change the input focus if we have been provided
            // with a defaultButtonIndex (that is also non-zero, as zero
            // would be the default anyway)
            if (defaultButtonIndex) {
                // WARNING: This may change with different versions of jQueryUI
                const $button = $(this).siblings('.ui-dialog-buttonpane').find('button:eq(' + defaultButtonIndex + ')');
                if ($button.length === 0) {
                    console.warn(
                        "Invalid value for defaultButtonIndex (%d), couldn't find a button at that index",
                        defaultButtonIndex
                    );
                } else {
                    $button.trigger("focus");
                }
            }
        }
    });

    $("<div></div>", {
        dialog: dialogOptions,
        css: {"white-space": "pre-line"},
        addClass: "exclaim-jquery-dialog",
        html: message
    });
}

// export function confirmDialogP(
//     message: string,
//     title: string,
//     buttonYes: string,
//     buttonNo: string,
//     defaultButtonIndex?: number,
// ): Promise<void>;
export function confirmDialogP(message, title, buttonYes, buttonNo, defaultButtonIndex) {
    return new Promise((resolve, reject) =>
        confirmDialog(message, title, buttonYes, buttonNo, resolve, reject, defaultButtonIndex)
    );
}

function buildYesNoButtons(buttonYes, buttonNo, callbackYes, callbackNo) {
    return [
        {
            text: buttonYes,
            click: function () {
                $(this).dialog("close");
                if (typeof callbackYes === "function") {
                    callbackYes();
                }
            },
        },
        {
            text: buttonNo,
            click: function () {
                $(this).dialog("close");
                if (typeof callbackNo === "function") {
                    callbackNo();
                }
            },
        },
    ];
}

// export function confirmDialog(
//     message: string,
//     title: string,
//     buttonYes: string,
//     buttonNo: string,
//     callbackYes?: () => void,
//     callbackNo?: () => void,
//     defaultButtonIndex?: number,
// ): void;
export function confirmDialog(message, title, buttonYes, buttonNo, callbackYes, callbackNo, defaultButtonIndex) {
    const buttons = buildYesNoButtons(buttonYes, buttonNo, callbackYes, callbackNo);
    confirm(message, title, buttons, null, null, defaultButtonIndex);
}

// export function confirmDialogWithCancel(
//     message: string,
//     title: string,
//     buttonYes: string,
//     buttonNo: string,
//     buttonCancel: string,
//     callbackYes?: () => void,
//     callbackNo?: () => void,
//     callbackCancel?: () => void,
//     defaultButtonIndex?: number,
// ): void;
export function confirmDialogWithCancel(message, title, buttonYes, buttonNo, buttonCancel, callbackYes, callbackNo, callbackCancel, defaultButtonIndex) {
    const buttons = buildYesNoButtons(buttonYes, buttonNo, callbackYes, callbackNo);
    buttons.push({
        text: buttonCancel,
        click: function () {
            $(this).dialog("close");
            if (typeof callbackCancel === "function") {
                callbackCancel();
            }
        },
    });
    confirm(message, title, buttons, null, null, defaultButtonIndex);
}

// export function toQueryString(obj: unknown, urlEncode? : boolean): string;
export function toQueryString(obj, urlEncode) {
    function crawler(object, key, level, parser) {
        parser(key, object);
        if (object && ($.isPlainObject(object) || Array.isArray(object))) {
            ++level;
            $.each(object, function (k, value) {
                let _key = k;
                if (Array.isArray(object)) {
                    _key = key;
                } else if ($.isPlainObject(object) && level > 1) {
                    _key = key + "[" + k + "]";
                }
                if (value !== undefined && value !== null && value !== object) {
                    crawler(value, _key, level, parser);
                }
            });
            --level;
        }
    }

    let result = "";
    crawler(obj, "data", 0, function (key, value) {
        if (value !== undefined && value !== null && typeof value !== "object") {
            if (urlEncode) {
                value = encodeURIComponent(value);
            }
            result += key + "=" + value + "&";
        }
    });
    result = result.slice(0, -1);
    return result;
}

// export function getCookie(cname: string): string;
export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
        const ct = c.trimStart();
        if (ct.startsWith(name)) {
            return ct.substring(name.length, ct.length);
        }
    }
    return "";
}

// export function alertError(errorMessage: string, callback?: () => void): void;
export function alertError(errorMessage,callback) {
    alertDialog(errorMessage, EX.Messages.prop("Dialog_error_title"), callback);
}

// export function genericAjaxOnFail(
//     jqXHR: JQueryXHR,
//     textStatus: JQuery.Ajax.ErrorTextStatus,
//     errorThrown?: string,
//     callback?: () => void
// ): void;
export function genericAjaxOnFail(jqXHR, textStatus, _errorThrown, callback) {
    const now = new Date();
    const msg = getAjaxFailErrorMessage(jqXHR, textStatus) +
        '\n\n' + now.toISOString();
    alertDialog(
        msg,
        EX.Messages.prop("Dialog_error_title"),
        callback
    );
}

// export function getJsonObjectFromResponse(jqXHR: JQueryXHR): unknown;
export function getJsonObjectFromResponse(jqXHR) {
    if (!jqXHR) {
        return undefined;
    }
    if (jqXHR.responseJSON || (jqXHR.responseType === "json" && jqXHR.response)) {
        return jqXHR.responseJSON || jqXHR.response;
    }
    return undefined;
}

// export function getAjaxFailErrorMessage(
//     jqXHR: JQueryXHR,
//     textStatus: JQuery.Ajax.ErrorTextStatus
// ): string;
export function getAjaxFailErrorMessage(jqXHR, textStatus) {
    return getServerRequestErrorMessage(
        jqXHR.status,
        textStatus,
        jqXHR.responseText,
        getJsonObjectFromResponse(jqXHR),
    );
}

// export function addSeparatorToString(input: string, format?: Array<number>, sep?: string): string;
export function addSeparatorToString(input, format, sep) {
    let output = "";
    let idx = 0;
    if (format && Array.isArray(format)) {
        for (let i = 0; i < format.length && idx < input.length; i++) {
            output += input.substring(idx, idx + format[i]);
            if (idx + format[i] < input.length) {
                output += sep;
            }
            idx += format[i];
        }
    }
    output += input.substring(idx);
    return output;
}

// export function validateFileName(fileName: string): boolean;
export function validateFileName(fileName) {
    return fileName.trim().length > 0 && ValidatorsObj.expressions.FILE_NAME.exec(fileName) === null;
}

// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export function isAllArraysOfEqualLength(...args: any): boolean;
export function isAllArraysOfEqualLength() {
    let l = null;
    let result = true;
    $.each(arguments, function (_i, array) {
        if (!Array.isArray(array)) {
            result = false;
            return result;
        } else if (l === null) {
            l = array.length;
        } else if (l !== array.length) {
            result = false;
            return result;
        }
    });
    return result;
}

/**
 * @param {{name:string, reverse?: boolean}} prop
 * @returns {(a: unknown, b: unknown) => 0|1|-1}
 */
// export function sortByPropertyFn(
//     prop: {name: string, reverse?: boolean}
// ): (a: unknown, b: unknown) => 0|1|-1;
export function sortByPropertyFn(prop) {
    return function (a, b) {
        const name = prop.name;
        const reverse = prop.reverse;
        if (a[name] < b[name]) {
            return reverse ? 1 : -1;
        }
        if (a[name] > b[name]) {
            return reverse ? -1 : 1;
        }
        return 0;
    };
}

// export function registerJQueryExtensions(): void;
export function registerJQueryExtensions() {

    $.fn.addSeparatorToValue = function (format, sep) {
        this.val(addSeparatorToString($(this).val().replace(sep, ""), format, sep));
    };

    $.fn.isVisible = function () {
        return this.length > 0 &&
                this.css('visibility') !== 'hidden' &&
                this.css('display') !== 'none';
    };

    /**
     * This function returns events registered by jQuery
     * @returns Object
     */
    $.fn.getEvents = function () {
        if (typeof (jQuery._data) === 'function') {
            return jQuery._data(this.get(0), 'events') || {};
        } else if (typeof (this.data) === 'function') { // jQuery version < 1.7.?
            return this.data('events') || {};
        }
        return {};
    };

    /**
     *  Add an event binding *before* any pre-existing bindings.
     */
    $.fn.addEventListenerBefore = function (type, data, fn) {
        const _fn = fn || data;
        this.each(function () {
            //Add the new event 'at the bottom'
            $(this).on(type, null, data, _fn);

            const handlers = $(this).getEvents()[type];

            //Only one handler.
            if (handlers.length === 1) {
                return true; //Continue
            }

            //Move last handler to first index.
            handlers.splice(0, 0, handlers.pop());
        });
        return this;
    };

    $.fn.disable = function () {
        const elements = $(this).find("input, select, textarea, button").addBack();
        $(elements).prop({
            "readonly": true,
            "disabled": true
        });
        $(elements).addClass("readOnlyClass");
        return this;
    };

    $.fn.enable = function () {
        const elements = $(this).find("input, select, textarea, button").addBack();
        $(elements).prop({
            "readonly": false,
            "disabled": false
        });
        $(elements).removeClass("readOnlyClass");
        return this;
    };

    $.ajaxSetup({
        beforeSend: commonAjaxBeforeSend
    });

    // jQuery ajax transport for making binary data type requests.
    // use this transport for "binary" data type
    $.ajaxTransport("+binary", function (options, _originalOptions, jqXHR) {
        // check for conditions and support for blob / arraybuffer response type
        if (window.FormData && ((options.dataType && (options.dataType === 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob)))))
        {
            return {
                // create new XMLHttpRequest
                send: function (headers, callback) {
                    // setup all variables
                    const xhr = new XMLHttpRequest(),
                            url = options.url,
                            type = options.type,
                            async = options.async || true,
                            // blob or arraybuffer. Default is blob
                            dataType = options.responseType || "blob",
                            data = options.data || null,
                            username = options.username || null,
                            password = options.password || null;

                    xhr.addEventListener('load', function () {
                        const data = {};
                        data[options.dataType] = xhr.response;
                        // make callback and send data
                        callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                    });

                    xhr.open(type, url, async, username, password);

                    // setup custom headers
                    for (const i in headers) {
                        xhr.setRequestHeader(i, headers[i]);
                    }

                    xhr.responseType = dataType;
                    xhr.send(data);
                },
                abort: function () {
                    jqXHR.abort();
                }
            };
        }
    });

    $.propHooks.disabled = {
        set: function (el, value) {
            $(el).toggleClass("readOnlyClass", value);
        }
    };

    $.expr.pseudos.contains = function (a, _i, m) {
        return (a.textContent || a.innerText || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    };

}
